export default "__VITE_ASSET__ad20f8b0__"